import { render, staticRenderFns } from "./AdvCustomer.vue?vue&type=template&id=61bdfec7&scoped=true&"
import script from "./AdvCustomer.vue?vue&type=script&lang=js&"
export * from "./AdvCustomer.vue?vue&type=script&lang=js&"
import style0 from "./AdvCustomer.vue?vue&type=style&index=0&id=61bdfec7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bdfec7",
  null
  
)

export default component.exports